import { ListItemText, Menu, MenuItem } from './index';
import { pagesText } from '../constants/pagesText';

const MENU_ITEM_STYLES = {
  padding: '8px',
  whiteSpace: 'normal',
};

const PRIMARY_STYLES = {
  fontSize: 12,
  lineHeight: '30px',
  fontWeight: 400,
  color: '#fff',
};

// Listing a resource a row does not have made the menu item a silent no-op, so each is gated on it.
const RESOURCE_ITEMS = [
  { source: 'securityCatalog', label: pagesText.securityExpandedRowActions.securityCatalog },
  {
    source: 'wdacPolicyWithFallback',
    label: pagesText.securityExpandedRowActions.securityPolicyWithFallback,
  },
];

const DownloadApplicationsMenu = ({
  anchorEl,
  onClose,
  onDownloadSecurityCatalog,
  onDownloadSecurityAllCatalog,
  originStyles,
  policies,
}) => (
  <Menu
    anchorEl={anchorEl}
    onClose={onClose}
    transformOrigin={originStyles.transformOrigin}
    anchorOrigin={originStyles.anchorOrigin}
    styles={{
      maxWidth: 175,
      boxShadow: 'unset',
    }}
    sx={{
      '& .MuiPaper-root': {
        marginTop: 0,
      },
    }}>
    {RESOURCE_ITEMS.filter(item => policies?.[item.source]?.key).map(item => (
      <MenuItem
        key={item.source}
        onClick={event => {
          event.stopPropagation();
          onDownloadSecurityCatalog(item.source);
        }}
        icon="material-symbols:download"
        styles={MENU_ITEM_STYLES}>
        <ListItemText primary={item.label} primaryStyles={PRIMARY_STYLES} />
      </MenuItem>
    ))}
    <MenuItem
      onClick={onDownloadSecurityAllCatalog}
      icon="material-symbols:download"
      styles={MENU_ITEM_STYLES}>
      <ListItemText
        primary={pagesText.securityExpandedRowActions.all}
        primaryStyles={PRIMARY_STYLES}
      />
    </MenuItem>
  </Menu>
);

export default DownloadApplicationsMenu;
